import Header from "../components/Header";
import HomeActivitiesSection from "../sections/home/HomeActivitiesSection";
import HomeCTASection from "../sections/home/HomeCTASection";
import HomeCompareSection from "../sections/home/HomeCompareSection";
import HomeFAQSection from "../sections/home/HomeFAQSection";
import HomeGrowSection from "../sections/home/HomeGrowSection";
import HomeHeroSection from "../sections/home/HomeHeroSection";
import HomeStartSellingSection from "../sections/home/HomeStartSellingSection";
import HomeWhySection from "../sections/home/HomeWhySection";

export default function Home() {
  return (
    <div className={ClassName.container}>
      <Header />
      <HomeHeroSection />
      <HomeWhySection />
      <HomeCompareSection />
      <HomeActivitiesSection />
      <HomeStartSellingSection />
      <HomeGrowSection />
      <HomeFAQSection />
      <HomeCTASection />
    </div>
  );
}

const ClassName = {
  container: "flex flex-col text-black relative font-main",
};
